// eslint-disable-next-line import/prefer-default-export
export const GET_CONTENT_TEMPLATES_RESPONSE_OK = [
  {
    id: 10013,
    contentType: 'Generic Content',
    descr: 'Lists - Picture',
  },
  {
    id: 10002,
    contentType: 'News',
    descr: 'Full - Default',
  },
];
